import React, { useEffect, useState } from "react";
import { CgChevronLeft, CgChevronRight } from "react-icons/cg";

import BackCard from "./items/BackCard";
import FrontCard from "./items/FrontCard";

function CardPreview({ theme, color }) {
  const [view, setView] = useState(true);
  const [display, setDisplay] = useState(() => {
    if (theme === "light") {
      return {
        backgroundDiv: "lightdivColor",
        text: "lighttextColor",
        button: "lightButton",
      };
    } else {
      return {
        backgroundDiv: "darkdivColor",
        text: "darktextColor",
        button: "darkButton",
      };
    }
  });

  useEffect(() => {
    if (theme === "light") {
      setDisplay({
        backgroundDiv: "lightdivColor",
        text: "lighttextColor",
        button: "lightButton",
      });
    } else {
      setDisplay({
        backgroundDiv: "darkdivColor",
        text: "darktextColor",
        button: "darkButton",
      });
    }
  }, [theme]);

  const handleView = () => {
    setView(!view);
  };

  return (
    <div className="card-preview divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Card</h5>
        <p className="text">Quick View</p>
      </div>
      <div className="preview">
        {view ? (
          <FrontCard display={display} color={color} />
        ) : (
          <BackCard display={display} color={color} />
        )}
      </div>
      <div className="indicator">
        {view ? (
          <span>
            <CgChevronRight size="2.2em" onClick={handleView} />
          </span>
        ) : (
          <span>
            <CgChevronLeft size="2.2em" onClick={handleView} />
          </span>
        )}
      </div>
    </div>
  );
}

export default CardPreview;
